import React, { useState } from "react";
import { Collapse, IconButton, Switch } from "@material-ui/core";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from "@material-ui/icons";

const OPTION_DEFINITIONS = [
  {
    key: "includeCrypto",
    label: "Crypto Sector",
    description: "Adds crypto stocks and the crypto index to the game",
    icon: "₿",
  },
  {
    key: "indexBuyingEnabled",
    label: "Index Buying",
    description: "Allow players to purchase sector index cards",
    icon: "📈",
  },
  {
    key: "dividendActionCardBonus",
    label: "Dividend Action Card",
    description: "On dividend rounds, all players receive 1 free action card (except final round)",
    icon: "🎁",
  },
  {
    key: "includeBubbleEvents",
    label: "Bubble Events",
    description: "Include bubble event cards that grow over time and can pop with big index swings",
    icon: "🫧",
  },
  {
    key: "firstPlayerEndOfRoundAction",
    label: "First Player End-of-Round Action",
    description: "First player gets 2 actions during their turn, then 1 action at end of round (shared timer)",
    icon: "⏰",
  },
];

const GameOptions = ({ gameOptions = {}, isHost = false, onUpdateOption }) => {
  const [expanded, setExpanded] = useState(true);

  const handleToggle = (key) => {
    if (!isHost || !onUpdateOption) return;
    onUpdateOption(key, !gameOptions[key]);
  };

  return (
    <div className="lobby-card game-options-card">
      <div
        className="card-header"
        style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}
        onClick={() => setExpanded(!expanded)}
      >
        <h2>⚙️ Game Options</h2>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          {!isHost && (
            <div style={{
              padding: "4px 12px",
              borderRadius: "12px",
              fontSize: "0.7rem",
              fontWeight: "bold",
              backgroundColor: "rgba(158, 158, 158, 0.12)",
              color: "#888",
              border: "1px solid rgba(158, 158, 158, 0.25)",
            }}>
              Host only
            </div>
          )}
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            }}
            style={{ padding: "4px" }}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      <Collapse in={expanded}>
        <div className="game-options-list">
          {OPTION_DEFINITIONS.map((option) => (
            <div
              key={option.key}
              className="game-option-row"
              onClick={() => handleToggle(option.key)}
              style={{ cursor: isHost ? "pointer" : "default" }}
            >
              <div className="game-option-icon">{option.icon}</div>
              <div className="game-option-info">
                <div className="game-option-label">{option.label}</div>
                <div className="game-option-description">{option.description}</div>
              </div>
              <Switch
                checked={!!gameOptions[option.key]}
                onChange={() => handleToggle(option.key)}
                disabled={!isHost}
                color="primary"
                size="small"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default GameOptions;
